import React from "react";
import PubSub from "pubsub-js";
//const FontAwesome = require('react-fontawesome');

class SkillComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            skillOn: false,
        };

        this._getColor = this._getColor.bind(this);
    }

    _onMouseOver(e) {
        if (this.props.context === "header") {
            var on = !this.state.skillOn;
            this.setState({
                skillOn: on,
            });
            // console.log(this.props)
            if (on) PubSub.publish("SKILL_ON", this.props.title);
            else PubSub.publish("SKILL_OFF", this.props.title);
        }
    }

    _onMouseOut(e) {
        //if(this.props.context == "header")
        //	PubSub.publish('SKILL_OFF', this.props.title);
    }

    _getColor() {
        let { color } = this.props;
        if (color && color.indexOf(",") > -1) color = color.split(",");
        return color;
    }

    _renderByName() {
        const { title } = this.props;
        const color = this._getColor();
        // console.log(color);
        switch (title) {
            case "JAMStack":
                var _parts = title.split("");
                const _spans = _parts.map((part, i) => {
                    return (
                        <span key={i} style={{ color: color[i] }}>
                            {_parts[i]}
                        </span>
                    );
                });
                return <div className="skill">{_spans}</div>;
            //break

            case "MEAN":
                var parts = title.split("");
                const spans = parts.map((part, i) => {
                    return (
                        <span key={i} style={{ color: color[i] }}>
                            {parts[i]}
                        </span>
                    );
                });
                return <div className="skill">{spans}</div>;
            //break

            default:
                return (
                    <div className="skill">
                        <span style={{ color }}>{title}</span>
                    </div>
                );
            //break
        }
    }

    componentDidUpdate() {
        //console.log(this.state)
    }

    render() {
        //const {skill} = this.props
        const skillClass = this.state.skillOn ? "active" : "";
        return (
            <div
                className={"skill-component " + skillClass}
                style={{
                    color: this._getColor(),
                }}
                onMouseOver={this._onMouseOver.bind(this)}
                onMouseOut={this._onMouseOut.bind(this)}
            >
                {this._renderByName()}
            </div>
        );
    }
}

SkillComponent.displayName = "SkillComponent";

// Uncomment properties you need
// SkillComponent.propTypes = {};
// SkillComponent.defaultProps = {};

export default SkillComponent;



// WEBPACK FOOTER //
// ./src/components/SkillComponent.js